import React from 'react';
import { renderTextWithNewlines } from '../utils/textUtils';

type TextPreviewProps = {
  text: string;
  className?: string;
};

/**
 * Component to preview text with proper newline rendering
 * Useful for showing how text will appear before posting
 */
const TextPreview: React.FC<TextPreviewProps> = ({ text, className = '' }) => {
  if (!text.trim()) {
    return (
      <div className={`text-gray-400 italic ${className}`}>
        پیش‌نمایش متن در اینجا نمایش داده می‌شود...
      </div>
    );
  }

  return (
    <div className={`whitespace-pre-wrap ${className}`}>
      {renderTextWithNewlines(text)}
    </div>
  );
};

export default TextPreview;